import React from 'react';

const TopBanner = (props) => {

    const customCSS = `announcement-topbanner announcement-topbanner-${props.ID}`;
    const target = (props.target) ? '_blank' : '_self';
    return (
        <div className={customCSS}>
            <a className="announcement-controls" onClick={props.onClose}><span className="icon-cancel"></span></a>
            <a href={props.link} target={target}>
                <div className="announcement-container">
                    {(props.image && (
                        <div className="announcement-image">
                            <img src={props.image} alt="Popup Image" />
                        </div>
                    ))}
                    <div className="announcement-content">
                        <div className="announcement-content-wrap">
                            <h6 dangerouslySetInnerHTML={{ __html: props.title }}></h6>
                            <p dangerouslySetInnerHTML={{ __html: props.text }}></p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    )
}
export default TopBanner;